{
  "auth": {
    "user_pool_id": "us-east-1_2hZ0pLr6J",
    "aws_region": "us-east-1",
    "user_pool_client_id": "3b8p5kobg1vltu37pueeeenmv1",
    "identity_pool_id": "us-east-1:e16c70b8-a774-4568-be8e-f7b4a4b0584a",
    "mfa_methods": [],
    "standard_required_attributes": [
      "email"
    ],
    "username_attributes": [
      "email"
    ],
    "user_verification_types": [
      "email"
    ],
    "groups": [
      {
        "admin": {
          "precedence": 0
        }
      },
      {
        "company": {
          "precedence": 1
        }
      },
      {
        "hotel": {
          "precedence": 2
        }
      },
      {
        "customer": {
          "precedence": 3
        }
      }
    ],
    "mfa_configuration": "NONE",
    "password_policy": {
      "min_length": 8,
      "require_lowercase": true,
      "require_numbers": true,
      "require_symbols": true,
      "require_uppercase": true
    },
    "unauthenticated_identities_enabled": true
  },
  "data": {
    "url": "https://3j47udyhunaxvhp44z4upufgbe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_region": "us-east-1",
    "default_authorization_type": "AMAZON_COGNITO_USER_POOLS",
    "authorization_types": [
      "AWS_IAM"
    ],
    "model_introspection": {
      "version": 1,
      "models": {
        "Picture": {
          "name": "Picture",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "url": {
              "name": "url",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Pictures",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Amenities": {
          "name": "Amenities",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "icon": {
              "name": "icon",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "title": {
              "name": "title",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Amenities",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ImportantInformation": {
          "name": "ImportantInformation",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "title": {
              "name": "title",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "info": {
              "name": "info",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ImportantInformations",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Includes": {
          "name": "Includes",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "included": {
              "name": "included",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Includes",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "MeetingPoint": {
          "name": "MeetingPoint",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "googleMapPoint": {
              "name": "googleMapPoint",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "MeetingPoints",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Store": {
          "name": "Store",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "location": {
              "name": "location",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "siteLocation": {
              "name": "siteLocation",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "phone": {
              "name": "phone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyID": {
              "name": "companyID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "company": {
              "name": "company",
              "isArray": false,
              "type": {
                "model": "Company"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "companyID"
                ]
              }
            },
            "activities": {
              "name": "activities",
              "isArray": true,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "storeID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Stores",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Activity": {
          "name": "Activity",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "productId": {
              "name": "productId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "topPick": {
              "name": "topPick",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "favorite": {
              "name": "favorite",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "mainActivityType": {
              "name": "mainActivityType",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "fullDescription": {
              "name": "fullDescription",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "duration": {
              "name": "duration",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "amenityTags": {
              "name": "amenityTags",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "bookingTag": {
              "name": "bookingTag",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "bookingTagActive": {
              "name": "bookingTagActive",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "sellOut": {
              "name": "sellOut",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "searchTags": {
              "name": "searchTags",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "rating": {
              "name": "rating",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "reviews": {
              "name": "reviews",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "pricePerPerson": {
              "name": "pricePerPerson",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "discountedPrice": {
              "name": "discountedPrice",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "peoplePerPrice": {
              "name": "peoplePerPrice",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "currencyType": {
              "name": "currencyType",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "highlights": {
              "name": "highlights",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "notSuitable": {
              "name": "notSuitable",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "storeID": {
              "name": "storeID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "language": {
              "name": "language",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "endDate": {
              "name": "endDate",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "archived": {
              "name": "archived",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "pictures": {
              "name": "pictures",
              "isArray": true,
              "type": {
                "model": "Picture"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "amenities": {
              "name": "amenities",
              "isArray": true,
              "type": {
                "model": "Amenities"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "importantInformation": {
              "name": "importantInformation",
              "isArray": true,
              "type": {
                "model": "ImportantInformation"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "includes": {
              "name": "includes",
              "isArray": true,
              "type": {
                "model": "Includes"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "meetingPoint": {
              "name": "meetingPoint",
              "isArray": true,
              "type": {
                "model": "MeetingPoint"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "store": {
              "name": "store",
              "isArray": false,
              "type": {
                "model": "Store"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "storeID"
                ]
              }
            },
            "availability": {
              "name": "availability",
              "isArray": true,
              "type": {
                "model": "Availability"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "favorites": {
              "name": "favorites",
              "isArray": true,
              "type": {
                "model": "Favorites"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "bookings": {
              "name": "bookings",
              "isArray": true,
              "type": {
                "model": "Booking"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Activities",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Booking": {
          "name": "Booking",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "date": {
              "name": "date",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "slots": {
              "name": "slots",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "pricePerSlot": {
              "name": "pricePerSlot",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "total": {
              "name": "total",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "storeName": {
              "name": "storeName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityName": {
              "name": "activityName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userID": {
              "name": "userID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "guestName": {
              "name": "guestName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "guestEmail": {
              "name": "guestEmail",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "guestPhone": {
              "name": "guestPhone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "bookingSource": {
              "name": "bookingSource",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "referralCode": {
              "name": "referralCode",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "hotelPartnerID": {
              "name": "hotelPartnerID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "hotelName": {
              "name": "hotelName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "hotelRoomNumber": {
              "name": "hotelRoomNumber",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "paymentIntentId": {
              "name": "paymentIntentId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "Users"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userID"
                ]
              }
            },
            "hotelPartner": {
              "name": "hotelPartner",
              "isArray": false,
              "type": {
                "model": "HotelPartner"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "hotelPartnerID"
                ]
              }
            },
            "payments": {
              "name": "payments",
              "isArray": true,
              "type": {
                "model": "Payments"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "bookingID"
                ]
              }
            },
            "referrals": {
              "name": "referrals",
              "isArray": true,
              "type": {
                "model": "BookingReferral"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "bookingID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Bookings",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "create"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "create"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company",
                      "hotel"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Users": {
          "name": "Users",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "phoneNumber": {
              "name": "phoneNumber",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyID": {
              "name": "companyID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "role": {
              "name": "role",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "company": {
              "name": "company",
              "isArray": false,
              "type": {
                "model": "Company"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "companyID"
                ]
              }
            },
            "favorites": {
              "name": "favorites",
              "isArray": true,
              "type": {
                "model": "Favorites"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userID"
                ]
              }
            },
            "bookings": {
              "name": "bookings",
              "isArray": true,
              "type": {
                "model": "Booking"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userID"
                ]
              }
            },
            "payments": {
              "name": "payments",
              "isArray": true,
              "type": {
                "model": "Payments"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Users",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "read"
                    ],
                    "groups": [
                      "company"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "hotel"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Categories": {
          "name": "Categories",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "subCategories": {
              "name": "subCategories",
              "isArray": true,
              "type": {
                "model": "SubCategories"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "categoryID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Categories",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "SubCategories": {
          "name": "SubCategories",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "categoryID": {
              "name": "categoryID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "category": {
              "name": "category",
              "isArray": false,
              "type": {
                "model": "Categories"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "categoryID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "SubCategories",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Availability": {
          "name": "Availability",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "date": {
              "name": "date",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "formattedDate": {
              "name": "formattedDate",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "timeSlots": {
              "name": "timeSlots",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Availabilities",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Company": {
          "name": "Company",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "contactName": {
              "name": "contactName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "contactEmail": {
              "name": "contactEmail",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "contactPhone": {
              "name": "contactPhone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "address": {
              "name": "address",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "website": {
              "name": "website",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "stores": {
              "name": "stores",
              "isArray": true,
              "type": {
                "model": "Store"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "companyID"
                ]
              }
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "Users"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "companyID"
                ]
              }
            }
          },
          "syncable": true,
          "pluralName": "Companies",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "HotelPartner": {
          "name": "HotelPartner",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "code": {
              "name": "code",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "contactName": {
              "name": "contactName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "contactEmail": {
              "name": "contactEmail",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "contactPhone": {
              "name": "contactPhone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "siteLocation": {
              "name": "siteLocation",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "address": {
              "name": "address",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "notes": {
              "name": "notes",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "commissionRate": {
              "name": "commissionRate",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "active": {
              "name": "active",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "bookings": {
              "name": "bookings",
              "isArray": true,
              "type": {
                "model": "Booking"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "hotelPartnerID"
                ]
              }
            },
            "referrals": {
              "name": "referrals",
              "isArray": true,
              "type": {
                "model": "BookingReferral"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "hotelPartnerID"
                ]
              }
            }
          },
          "syncable": true,
          "pluralName": "HotelPartners",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "hotel"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "PotentialCompanyInfo": {
          "name": "PotentialCompanyInfo",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "companyName": {
              "name": "companyName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyContactName": {
              "name": "companyContactName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyContactEmail": {
              "name": "companyContactEmail",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyDescription": {
              "name": "companyDescription",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "PotentialCompanyInfos",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "create"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "create"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Favorites": {
          "name": "Favorites",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userID": {
              "name": "userID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activityID": {
              "name": "activityID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "activity": {
              "name": "activity",
              "isArray": false,
              "type": {
                "model": "Activity"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "activityID"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "Users"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Favorites",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Payments": {
          "name": "Payments",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "amount": {
              "name": "amount",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "currency": {
              "name": "currency",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "bookingID": {
              "name": "bookingID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userID": {
              "name": "userID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "booking": {
              "name": "booking",
              "isArray": false,
              "type": {
                "model": "Booking"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "bookingID"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "Users"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userID"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Payments",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "BookingReferral": {
          "name": "BookingReferral",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "bookingID": {
              "name": "bookingID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "hotelPartnerID": {
              "name": "hotelPartnerID",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "referralCode": {
              "name": "referralCode",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "source": {
              "name": "source",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "commissionRate": {
              "name": "commissionRate",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "commissionAmount": {
              "name": "commissionAmount",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "notes": {
              "name": "notes",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "booking": {
              "name": "booking",
              "isArray": false,
              "type": {
                "model": "Booking"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "bookingID"
                ]
              }
            },
            "hotelPartner": {
              "name": "hotelPartner",
              "isArray": false,
              "type": {
                "model": "HotelPartner"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "hotelPartnerID"
                ]
              }
            }
          },
          "syncable": true,
          "pluralName": "BookingReferrals",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "hotel"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "SiteConfiguration": {
          "name": "SiteConfiguration",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "location": {
              "name": "location",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "siteName": {
              "name": "siteName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "logoUrl": {
              "name": "logoUrl",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "logoKey": {
              "name": "logoKey",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "headerImageUrl": {
              "name": "headerImageUrl",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "headerImageKey": {
              "name": "headerImageKey",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "faviconUrl": {
              "name": "faviconUrl",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "faviconKey": {
              "name": "faviconKey",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "primaryColor": {
              "name": "primaryColor",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "secondaryColor": {
              "name": "secondaryColor",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "active": {
              "name": "active",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "metadata": {
              "name": "metadata",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            }
          },
          "syncable": true,
          "pluralName": "SiteConfigurations",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "allow": "public",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "provider": "iam",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ],
                    "groups": [
                      "admin",
                      "company"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        }
      },
      "enums": {},
      "nonModels": {}
    }
  },
  "storage": {
    "aws_region": "us-east-1",
    "bucket_name": "amplify-d3n5brq70y30r6-re-basiliskbookingstoragebu-kfyqdilyfaaq",
    "buckets": [
      {
        "name": "basiliskBookingStorage",
        "bucket_name": "amplify-d3n5brq70y30r6-re-basiliskbookingstoragebu-kfyqdilyfaaq",
        "aws_region": "us-east-1",
        "paths": {
          "public/*": {
            "guest": [
              "get",
              "list"
            ],
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "protected/{identity_id}/*": {
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "private/{identity_id}/*": {
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "uploads/*": {
            "guest": [
              "get",
              "list"
            ],
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "activity-images/*": {
            "guest": [
              "get",
              "list"
            ],
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "user-uploads/*": {
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "site-config/*": {
            "guest": [
              "get",
              "list"
            ],
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          }
        }
      }
    ]
  },
  "version": "1.4",
  "custom": {
    "adminFunctionUrl": "https://orxpvfn6wclzsly2cc5rmztntq0oaivo.lambda-url.us-east-1.on.aws/",
    "stripeFunctionUrl": "https://5pissh7sjzugdc6mbr7mivip4m0mxizm.lambda-url.us-east-1.on.aws/",
    "emailFunctionUrl": "https://4sfofgmuqkhdmrxragjnkoayle0lbouj.lambda-url.us-east-1.on.aws/"
  }
}